var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',[(_vm.snackbarVisible)?_c('div',{staticClass:"snackbar",class:`snackbar--${_vm.snackbarStatus}`},[_c('div',{staticClass:"snackbar__text"},[_vm._v(_vm._s(_vm.snackbarText))]),_c('strong',{staticClass:"snackbar__icon-close",on:{"click":_vm.hideSnackbar}},[_vm._v("✕")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }